<template>
  <el-card
    id="myActionPlanCard"
    v-loading="loading"
    shadow="hover"
    class="clear-card myActionPlan"
    :class="$mq"
  >
    <div
      slot="header"
      class="clearfix title defaultCursor"
    >
      <span>{{ $t('aside.actionPlan') }}</span>
    </div>
    <div class="content">
      <div
        v-if="actionPlan && actionPlan.length"
        class="charts"
      >
        <OverviewChart
          key="realAP"
          :chart-data="actionPlan"
          type-display="small"
        />
      </div>
      <div
        v-else
        class="no-data"
      >
        {{ $t('common.noData') }}
      </div>
    </div>
    <div
      v-if="actionPlan && actionPlan.length"
      class="footer"
    >
      <el-button
        class="footerBtn"
        round
        @click="goToActionPlan"
      >
        {{ $t('settings.viewDetails') }}
      </el-button>
    </div>
  </el-card>
</template>

<script>
export default {
  components: {
    OverviewChart: () => import(/* webpackChunkName: "Charts" */ '@/views/dashboard/content/leader/actionPlan/overview/OverviewChart.vue'),
  },

  props: {
    engagementUuid: {
      type: String,
      default: '1',
    },

    actionPlan: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      session: 10, // TMP
    };
  },

  watch: {
    session() {
      this.getOverviewStat();
    },
  },

  methods: {
    goToActionPlan() {
      this.$router.push({
        name: 'leaderEngagementActionPlan',
        params: {
          id: this.engagementUuid,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #myActionPlanCard {
    height: 100%;

    .title {
      text-align: center;
    }

    &:not(.mobile):not(.tablet) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 100%;
      min-height: 120px;
      align-items: center;
      font-style: italic;
      text-align: center;
      color: #c4c4c4;
      margin-left: -20px;

      .charts {
        width: 100%;
        padding-top: 35px;
      }

      .no-data {
        margin-left: 40px;
      }
    }

    .footer {
      text-align: center;
      .footerBtn {
        background-color: transparent;
        color: var(--themeFontColor);
      }
    }
  }
</style>

<style lang="scss">
  #myActionPlanCard {
    .el-card__header {
      font-weight: bold;
    }

    &.mobile,
    &.tablet {
      .el-card__header {
        border-bottom: 0;
      }
    }
  }
</style>
